import React from 'react';
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";

import './RateizzazioneBollettaCase.scss';

const RateizzazioneBollettaCase = () => {
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  return (
    <div
      className="RateizzazioneBollettaCase"
      data-testid="RateizzazioneBollettaCase"
    >
      <CaseGenerator
        type={CaseForms.RateizzazioneBolletta}
        initialValues={
          {...profile,
           ...((profile.role === UserRoleEnum.PRIVATE || profile.businessName==='') && { businessName: `${profile.name} ${profile.surname}` }),
          }
         }
      />
    </div>
  );
};

export default RateizzazioneBollettaCase;
